const isDemo = process.env.REACT_APP_THEME === 'demo';

export default (theme) => ({
  root: {},
  header: {
    position: 'sticky',
    top: 0,
    zIndex: 1,
    backgroundColor: isDemo ? '#f5fdfe' : '#f6feff',
    background: isDemo ? 'linear-gradient(180deg,#f1fcfe,#ffffff)' : undefined,
  },
  headerRow: {
    display: 'flex',
    borderBottom: isDemo ? '1px solid #e4eef0' : `1px solid ${theme.palette.primary.main}`,
    height: isDemo ? 44 : 56,
  },
  headerColumn1: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: isDemo ? '0.82rem' : '1.125rem',
    color: isDemo ? '#7c8a8d' : 'rgba(0, 0, 0, 0.54)',
  },
  headerColumn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  headerColumnText: {
    fontSize: isDemo ? '0.82rem' : '1.125rem',
    fontWeight: isDemo ? 600 : undefined,
    color: isDemo ? '#7c8a8d' : 'rgba(0, 0, 0, 0.54)',
  },
  profilePicture: {
    height: 30,
    width: 30,
    borderRadius: 15,
  },
  body: {
    overflow: 'auto',
  },
  bodyRow: {
    display: 'flex',
    height: isDemo ? 42 : 48,
    '&:hover': {
      backgroundColor: isDemo ? 'rgba(191,247,255,0.18)' : 'rgba(0, 0, 0, 0.07)',
    },
    borderBottom: isDemo ? '1px solid #eef4f5' : `1px solid ${theme.palette.primary.light}`,
  },
  bodyColumn1: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  bodyColumn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  bodyColumnText: {
    fontSize: '0.875rem',
    whiteSpace: 'nowrap',
  },
  arrowIcon: {
    fontSize: 20,
    paddingLeft: 8,
    paddingRight: 8,
    width: 36,
    color: '#272727',
  },
});
